'use client';

import { EditorShareView } from './EditorShareView';
import { FullShareView } from './FullShareView';
import { ModalLayoutShareView } from './ModalLayoutShareView';

export interface ShareModalClientProps {
  shareUrl: string | null;
  siteName?: string;
  imageUrl?: string;
  siteUrl?: string;
  ownerUrl?: string;
  commentsCount: number;
  unreadCount: number;
  origin?: string;
  /** Conducted bmHarmonyTheme variant; 'A' (off) renders the WDS-style layout. */
  bmHarmonyTheme?: 'A' | 'B';
  onClose?: () => void;
  showFootnote?: boolean;
}

export function ShareModalClient({
  origin,
  bmHarmonyTheme,
  ...rest
}: ShareModalClientProps) {
  if (origin === 'editor') {
    return <EditorShareView {...rest} />;
  }
  if (bmHarmonyTheme === 'A') {
    return <ModalLayoutShareView {...rest} />;
  }
  return <FullShareView {...rest} />;
}
